<template>
  <v-row>
    <v-col class="d-block" cols="12">
      <v-alert
        type="error"
        color="error lighten-1"
        class="mb-0"
      >
        ACCOUNT RESTRICTED - {{ banReason }}
      </v-alert>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BanAlert',
  computed: mapGetters([
    'banReason'
  ]),
}
</script>
